import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import { Bookmark, ClipboardX, Cloud, CloudDownload, Donut, EllipsisVertical, Expand, FileCheck2, FolderPlus } from "lucide-react";
import UniversalVideoPlayer from "../../CreateWebsite/VideoPlayer/UniversalVideoPlayerWebUI";


const FileItemCard =({getFileObject,item,setCloseQuickViewPopUp,setQuickViewItem,downloadFileClick,videoSettingsObject,setCloseFileListsPopUp})=>{
   
    const [active , setActive] = useState({status:false});
                    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
                     const [isLoaded, setIsLoaded] = useState(false);
                     const [hasError, setHasError] = useState(false);
                     
                        
                             const [reloadItems, setReloadItems] = useState(true);
                            
                                useEffect(()=>{
                                    setReloadItems(false); setReloadItems(true);
                                    
                                },[ ])
                   
                                  
                     return (
                       <div style={{ position: "relative",boxShadow:boxShadow,
                       overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
                        borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                                 
                       width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
                         {!isLoaded && !hasError && (
                           <div
                            style={
                                { 
                                 borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         width: `${width}%`,
                         aspectRatio: aspectRatio,
                         objectFit: "cover",  }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                           >
                             <img
                           src={loading_img}
                           alt=""
                         
                          style={
                                {
                                borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                                 
                                   position: "absolute",border:border,
                         top: 0,
                         left: 0,
                         width: `${width}%`,padding:"10px",
                       
                         objectFit: "cover", aspectRatio: aspectRatio,  }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                         />
                           </div>
                         )}
                         
                         <img
                   
                         
                           src={hasError ? fallback_img : src}
                           alt=""
                           onLoad={() => setIsLoaded(true)}
                           onError={() => setHasError(true)}
                          style={
                                {
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         width: `${width}%`,
                        
                         objectFit: "cover",aspectRatio: aspectRatio  }}
                        
                         />
                       
                       </div>
                     );
                   }; 
    return(<>
    <div className="fileCardOuter">
        <div className="openInfoOuter" style={{cursor:"pointer",width:"25px",height:"25px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"rgba(144, 202, 249,1)",position:"absolute",right:"5px",top:"5px",zIndex:"99999"}}>
<EllipsisVertical size={15} color={"#ffffff"} />
<div className="openInfoInner">
 
    <div className="openInfoInnerItem">
     <label className={"checkbox-outer  "}  style={{marginTop:"-5px",marginLeft:"-5px"}}>
                                        
                                        <span style={{position:"relative",top: "-1px" ,left:"-2px",fontSize:"14px",textTransform: "capitalize"}}>{active?.status?"Deselect":"Select"} {item?.mime_type}</span>
                                       
                                                <input  type={"checkbox"} title={item?.file_name}
                                                 className="input-textbox"  checked= {active?.status} value={item?.file_s3_key} name={"selectFile"}  
     onChange={e=>{ setActive({...active,status:!active.status});getFileObject(item)
        
        
       }
       
    }
    />
                                                   <span class={"square"} style={{border:"3px solid rgba(144, 202, 249,1)",transform:"scale(0.6)",borderRadius:"5px",}}></span>
                                          </label>
                                           
    </div>
     <div onClick={()=>{setCloseQuickViewPopUp();setQuickViewItem(item)}} className="openInfoInnerItem">
     <Expand size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Show Details</span>
    </div> <div onClick={()=>{downloadFileClick(item);}} className="openInfoInnerItem">
     <CloudDownload size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Download</span>
    </div> <div  onClick={()=>{setCloseFileListsPopUp(item)}} className="openInfoInnerItem">
     <FolderPlus size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Add To List</span>
    </div> <div className="openInfoInnerItem">
     <ClipboardX size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Move To Trash</span>
    </div>
</div>
        </div>
        
       {item?.mime_type=="image"?
 <ImageFallFB  boxShadow={``}
                      src={item?.fileUrl}
                      border={{}}
                      width={ 100
                      }
                      aspectRatio={3/2}
                      borderRadius={ {}
                      }/>:item?.mime_type=="video"?<div style={{position:"absolute",bottom:"0px",left:"0px",right:"0px",top:"0px",overflow:"hidden"}}>
                      <div style={{width:"400px",position:"absolute",bottom:"0px",left:"-110px",right:"0px",top:"-42px",transform:"scale(0.5)",borderRadius:"10px"}}>
                      <UniversalVideoPlayer  videoSettings={videoSettingsObject} videoUrl={item?.fileUrl} minHeight={240} maxHeight={240}/></div></div>:""}
                      
                      
           {item?.mime_type!=="video"?  <div onClick={()=>{setCloseQuickViewPopUp();setQuickViewItem(item)}} className="openInfoOuter" style={{border:"2px solid #ffffff",cursor:"pointer",width:"25px",height:"25px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"50px",background:"rgba(144, 202, 249,1)",position:"absolute",right:"70px",bottom:"45px",zIndex:"99"}}>
<Expand size={15}  color="#ffffff" />
</div> :""}

                        <div onClick={()=>{downloadFileClick(item);}} className="openInfoOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"25px",height:"25px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"#ffffff",position:"absolute",right:"5px",bottom:"5px",zIndex:"99"}}>
<CloudDownload size={18} color={"rgba(144, 202, 249,1)"} />
</div> 
 <div onClick={()=>{setCloseFileListsPopUp(item)}} className="openInfoOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"50px",background:"#ffffff",position:"absolute",right:"65px",bottom:"-20px",zIndex:"99"}}>
<Bookmark size={18} color={"rgba(144, 202, 249,1)"} />
</div> 

  <div className="openInfoOuter" style={{cursor:"pointer",position:"absolute",left:"5px",top:"5px",zIndex:"99"}}>

<label className={"checkbox-outer  "} >
                                        
                                        
                                       
                                                <input  type={"checkbox"} title={item?.file_name}
                                                 className="input-textbox"  checked= {active?.status} value={item?.file_s3_key} name={"selectFile"}  
     onChange={e=>{ setActive({...active,status:!active.status});getFileObject(item)
        
        
       }
       
    }
    />
                                                   <span class={"square"} style={{border:"3px solid rgba(144, 202, 249,1)",transform:"scale(0.9)",borderRadius:"5px",}}></span>
                                          </label>
    </div>   </div>
    <style>
    {`
    .openInfoInnerItem{height:20px;cursor:pointer;display:flex;justify-content:left;gap:8px;background:#fff;padding:3px 5px;border-radius:5px;margin-bottom:5px}
    .openInfoOuter .openInfoInner{border:2px solid rgba(144, 202, 249,1);width:125px;height:150px;background:rgba(228, 237, 244, 1);;border-radius:5px;position:absolute;top:-10px;right:33px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .openInfoOuter:hover .openInfoInner{visibility:visible;opacity:1;transition: 0.1s ease;padding:5px}
    .fileCardOuter{ position:relative;
    background:rgba(144, 202, 249,0.1);
    width:160px;padding:5px;
    border:3px solid rgba(144, 202, 249,1);transform:scale(1);transition: 0.1s ease;
    height:105px;border-radius:10px;margin-bottom:20px;
    }
   .openInfoInner::after {
    content: "";
    position: absolute;
   top: 0px;
    right: -16px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent   transparent rgba(144, 202, 249,1) ;
  }
    .fileCardOuter:hover, .openInfoInnerItem:hover{transform:scale(0.9);transition: 0.1s ease;}
    `}
    </style>
    </>)
}
export default FileItemCard;